import { useResponsive } from '@garnish/core';

import { useIsFoldableDevice } from '../../../hooks/useIsFoldableDevice';
import { type ScreenOptions } from '../../constants';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the presentation of the modals stack for the current display.
 *
 * NOTE: iOS keeps a modal's presentation until it closes, so a sheet opened
 *       on a foldable's closed display turns into a centred card once the
 *       device opens. Foldables use the open display's presentation on both
 *       displays, which also keeps the screen below for the open layouts.
 */
export const useModalsPresentation = () => {
  const { match } = useResponsive();
  const isFoldableDevice = useIsFoldableDevice();

  // ─── Derived ─────────────────────────────────────────────────────────

  const closedDisplayModalsPresentation: ModalsPresentation = isFoldableDevice
    ? 'transparentModal'
    : 'modal';

  return match<ModalsPresentation>([closedDisplayModalsPresentation, 'transparentModal']);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ModalsPresentation = ScreenOptions['presentation'];
